<template>
  <div>
    <v-container>
      <div class="text-h5 font-weight-bold">個人疾病史</div>
      <div class="d-flex flex-wrap">
        <div class="item-personal-record" v-for="key of 個人疾病史">
          <v-checkbox
            v-model="問卷['個人' + key]"
            :label="key"
            hide-details
          ></v-checkbox>
        </div>
        <div class="item-personal-record">
          <v-checkbox label="無" hide-details></v-checkbox>
        </div>
      </div>
    </v-container>
    <v-container>
      <div class="text-h5 font-weight-bold">個人用藥與就診紀錄</div>

      <div class="mt-6">
        <div class="font-weight-bold">是否有長期用藥</div>
        <div class="mt-2 d-flex">
          <div>
            <v-checkbox
              class="mt-0"
              v-model="問卷.長期用藥"
              label="是"
              hide-details
            ></v-checkbox>
          </div>
          <div v-if="問卷.長期用藥" class="ml-8" style="margin: -6px">
            <v-text-field
              class="mt-0 inline-block"
              v-model="問卷.長期用藥原因"
              label="長期用藥原因"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>
          <div>
            <v-checkbox class="mt-0 ml-8" label="無" hide-details></v-checkbox>
          </div>
        </div>
      </div>

      <div class="mt-6" v-if="this.性別 == '女'">
        <div class="font-weight-bold">
          最近兩年內是否曾做過下列檢查（可複選）？
        </div>
        <div class="mt-2">
          <div class="item-personal-record">
            <v-checkbox
              class="mt-0"
              v-model="問卷.醫療人員乳房觸診"
              label="醫療人員乳房觸診"
              hide-details
            ></v-checkbox>
          </div>
          <div class="item-personal-record">
            <v-checkbox
              class="mt-0"
              v-model="問卷.乳房超音波檢查"
              label="乳房超音波檢查"
              hide-details
            ></v-checkbox>
          </div>
          <div class="item-personal-record">
            <v-checkbox
              v-if="person.篩檢項目.成健"
              class="mt-0"
              v-model="問卷.乳房攝影X光檢查"
              label="乳房攝影X光檢查"
              hide-details
            ></v-checkbox>
          </div>
          <div class="item-personal-record">
            <v-checkbox class="mt-0" label="無" hide-details></v-checkbox>
          </div>
        </div>
      </div>

      <div class="mt-6" v-if="問卷.高血壓 || 問卷.糖尿病 || 問卷.高血脂症">
        <div class="font-weight-bold">
          是否因高血壓、高血脂或糖尿病在醫療院所規律就診
        </div>
        <div class="mt-2 d-flex">
          <div>
            <v-checkbox
              class="mt-0"
              v-model="問卷.規律就診"
              label="是"
              hide-details
            ></v-checkbox>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { 個人疾病史 } from "@/libs/const.js";
import util from "@/mixins/util";
export default {
  name: "QuestionContent",
  props: ["valid", "person", "問卷"],
  mixins: [util],
  data: () => ({
    個人疾病史,
  }),
};
</script>

<style lang="scss" scoped>
.item-personal-record {
  width: 180px;
  display: inline-block;
}
</style>
